import React, { PureComponent } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

const COLORS = ["#C03E5A", "rgba(242, 205, 137, 1)", "#54C06C", "rgba(189, 189, 189, 1)"];

const colorsTwo = [
  "#D57DF5",
  "#7E69D7",
  "#2F80ED",
  "#56CCF2",
  "#52FFD3",
  "#5BCF74",
  "#96E964",
  "#FFCF71",
  "#F97255",
  "#FF84CE"
];

export default class OptimizerPieChart extends PureComponent {
  render() {
    const { isSmall, pData, secondaryColors, unit, onClick } = this.props;

    if (pData === undefined) {
      return <div />;
    }

    const total = pData.reduce((a, b) => a + b.value, 0);

    return (
      <ResponsiveContainer>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie
            data={pData}
            innerRadius={isSmall ? 15 : 30}
            outerRadius={isSmall ? 25 : 50}
            fill="#8884d8"
            paddingAngle={1}
            dataKey="value"
            onClick={
              !onClick
                ? undefined
                : (e) => e && e.payload && e.payload.payload && onClick(e.payload.payload.runId, e.payload.payload.name)
            }
          >
            {pData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                stroke="rgba(255,255,255,0)"
                fill={
                  entry.color
                    ? entry.color
                    : secondaryColors
                      ? colorsTwo[index % colorsTwo.length]
                      : COLORS[index % COLORS.length]
                }
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name, props) => unit + value + " (" + Math.round((props.value / total) * 100) + "%)"}
          />
          <Legend
            layout={"vertical"}
            align={"right"}
            verticalAlign={"middle"}
            formatter={(value, entry, index) => value + ": " + Math.round((pData[index].value / total) * 100) + "%"}
            iconType={"circle"}
          />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}
